export const InsightsPolicyType = {
    ARMORCODE_BEST_PRACTICES: "ARMORCODE_BEST_PRACTICES",
    CWE: "CWE",
    CWE_TOP_25: "CWE_TOP_25",
    FEDRAMP: "FEDRAMP",
    FINDINGS: "FINDINGS",
    OWASP_TOP_10_2017: "OWASP_TOP_10_2017",
    OWASP_TOP_10_2021: "OWASP_TOP_10_2021",
    SOC2: "SOC2",
    DEVELOPER: "DEVELOPER",
    BY_COMPONENT: "BY_COMPONENT",
    BY_SUMMARY: "BY_SUMMARY",
    BY_FILE_NAME: "BY_FILE_NAME",
    BY_NEW_FILE_NAME: "BY_NEW_FILE_NAME",
    URL: "URL",
    CVE: "CVE",
    BY_DEVICE: "DEVICE",
    BY_TAG: "TAG",
    ASVS: "ASVS_4_0_2"
}

export const PRODUCT_FILTER_KEYS = ['environmentName', 'product', 'subProduct']

export const TICKET_SYSTEM_CONFIG_ERROR = 'Ticket system configuration has errored, Please check configuration.'